import { TriangleAlert } from 'lucide-react';

import useTranslations from '@/lang/useTranslations';
import { TenkoButton } from '@/shared/components/buttons/TenkoButton';
import { TenkoEmpty } from '@/shared/components/feedback/TenkoEmpty';

interface AppErrorFallbackProps {
  /** Clears the boundary and re-renders the tree. From `Sentry.ErrorBoundary`. */
  resetError: () => void;
}

/**
 * What the user sees when a render throws. Lives in `src/platform/` rather than
 * the design system because it reads translations, which `src/shared/**` is not
 * allowed to import.
 *
 * Only offers a retry: a remount fixes a transient failure, and a permanent one
 * leaves the message on screen instead of a blank page.
 */
export const AppErrorFallback = ({ resetError }: AppErrorFallbackProps) => {
  const { translation: t } = useTranslations('global');

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-6">
      <TenkoEmpty
        icon={TriangleAlert}
        title={t('app_error_title')}
        description={t('app_error_description')}
      >
        <TenkoButton onClick={resetError}>{t('app_error_retry')}</TenkoButton>
      </TenkoEmpty>
    </div>
  );
};
